var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLoading)?_c('div',{staticClass:"preloader"},[_vm._m(0)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"preloader-container"},[_c('div',{staticClass:"thecube"},[_c('div',{staticClass:"cube c1"}),_c('div',{staticClass:"cube c2"}),_c('div',{staticClass:"cube c4"}),_c('div',{staticClass:"cube c3"})])])
}]

export { render, staticRenderFns }